// extracted by mini-css-extract-plugin
module.exports = {"plusButton":"IndicatorsContainer_plusButton__cAAZh"};